export default __webpack_public_path__ + "static/media/Overgrowth.1f472dcf.jpg";